import SvgIcon from "@mui/material/SvgIcon"

export default function VegaChatIcon() {
  return (
    <SvgIcon>
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
          <title>VEGA Icon</title>
          <g id="Marketing-Sheets" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Integration-Kaplan" transform="translate(-758, -1254)">
                  <g id="Team-Key" transform="translate(758, 1155)">
                      <g id="VEGA-Icon" transform="translate(0, 99)">
                          <circle id="Oval" fill="currentColor" cx="12" cy="12" r="12"></circle>
                          <g id="VEGA-White-Icon-No-Padding" transform="translate(3.5, 5.5)" fill="#FFFFFF" fillRule="nonzero">
                              <polygon id="Rectangle" points="0 8.02830024e-15 4.88888888 0 10.4761905 16 6.43386244 16"></polygon>
                              <polygon id="Rectangle" transform="translate(13.1429, 6.963) scale(-1, 1) translate(-13.1429, -6.963)" points="9.29100402 8.02830024e-15 14.1798929 0 16.9947077 7.95767197 14.9206336 13.9259259"></polygon>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </SvgIcon>
  )
}
